<template>
  <minimap :height="200" />
</template>

<script>
import { Minimap } from '../../index'
export default {
  name: 'EditorMinimap',
  components: { Minimap },
}
</script>
